module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoBasquetbol-457d5249.jpg";